import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import POS from "./pages/pos/POS";
import Confirmation from "./pages/pos/Confirmation";
import Orderhistory from "./pages/pos/Order-history";
import { CheckoutPage } from "./pages/pos/CheckoutPage";
import Cookies from "js-cookie";
import { verifyToken } from "./utils/auth";
import Profile from "./pages/pos/Profile";
import { Address } from "./pages/pos/Address";
import { useAuth } from "./context/AuthContext";
import { Wallet } from "./pages/pos/Wallet";
import Account from "./pages/pos/account";
import GiftCards from "./pages/pos/GiftCards";
import LoyaltyPoints from "./pages/pos/LoyaltyPoints";
import PageTitle from "./PageTiltle";
const App: React.FC = () => {
  const token = Cookies.get("Logintoken");
  const { user, setUser } = useAuth();
  const [isTokenValid, setIsTokenValid] = React.useState<boolean | null>(null);

  useEffect(() => {
    const root = document.documentElement;
    const applyTheme = (theme: string | null) => {
      if (theme === "dark") {
        root.classList.add("theme-dark");
        return;
      }
      if (theme === "light") {
        root.classList.remove("theme-dark");
        return;
      }
      const prefersDark =
        window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
      if (prefersDark) {
        root.classList.add("theme-dark");
      } else {
        root.classList.remove("theme-dark");
      }
    };

    const stored = localStorage.getItem("pos_theme");
    applyTheme(stored);

    const handleStorage = (event: StorageEvent) => {
      if (event.key === "pos_theme") {
        applyTheme(event.newValue);
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        setIsTokenValid(false);
        window.hasVerifiedToken = false;
        return;
      }

      // ✅ Check the flag BEFORE verification
      if (window.hasVerifiedToken) {
        // Already verified (either from login or previous check)
        setIsTokenValid(true);
        return;
      }

      // Only verify if not already verified
      const userData = await verifyToken(setIsTokenValid);
      if (!userData) {
        setIsTokenValid(false);
        return;
      }
      setUser(userData);

      window.hasVerifiedToken = true; // Mark as verified
    };

    checkToken();
  }, [token, setUser]);
  return (
    <Router>
         <Toaster position="top-center" reverseOrder={false}
  containerStyle={{
    zIndex: 99999,
  }}
/>
      <Routes>

        <Route path="/" element={<Outlet />}>
          <Route path="confirmation/:orderId" element={<><PageTitle title="Confirmation" /><Confirmation /></>} />
          <Route path="" element={<POS />} />
          <Route path="checkout" element={ <><PageTitle title="Checkout" /> <CheckoutPage /></>} />
          <Route path="account" element={<><PageTitle title="My Account" /> <Account /></>} />
          <Route path="my-orders" element={<><PageTitle title="Order History" /> <Orderhistory /></>} />
          <Route path="profile" element={<><PageTitle title="My Profile" /> <Profile /></>} />
          <Route path="address" element={<><PageTitle title="Manage Address" /><Address /></>} />
          <Route path="wallet" element={<><PageTitle title="My Wallet" /><Wallet /></>} />
          <Route path="gift-cards" element={<><PageTitle title="Gift Cards" /><GiftCards /></>} />
          <Route path="Loyalty"element={<><PageTitle title="Loyalty Program" /><LoyaltyPoints /></>} />
        </Route>
        {/* Kitchen login */}
      </Routes>
    </Router>
  );
};

export default App;
